import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardTitle } from 'reactstrap';

import './styles.scss';
import mailIconDark from '../../../../assets/mail-icon_dark.svg';
import mailIconWhite from '../../../../assets/mail-icon_white.svg';
import AddressCompanyIconWhite from '../../../../assets/location_map_white.svg';
import AddressCompanyIconDark from '../../../../assets/location_map_dark.svg';
import userIconDark from '../../../../assets/user_standard_dark.svg';
import userIconWhite from '../../../../assets/user_standard_white.svg';
import BranchAddressIconDark from '../../../../assets/location_branch_dark.svg';
import BranchAddressIconWhite from '../../../../assets/location_branch_white.svg';
import '../DashboardContent/styles.scss';
import { BRANCH_NOT_FOUND } from '../../../ProfilePage/constants';

const CardUserInfo = ({
  address,
  email,
  userFunction,
  isCompanyAdmin,
  pictureSrc,
  children,
  styleVariant,
  branchAddress,
  clientIconUrl,
  clientIconName,
  firstName,
  lastName,
}) => {
  const { t } = useTranslation();

  const isDarkMode =
    window.matchMedia('(prefers-color-scheme: dark)').matches || window.matchMedia('(color-scheme: dark)').matches;

  const userFunctionLabel = isCompanyAdmin
    ? [t(`function.values.${userFunction}`), '(' + t('userCard.companyAdmin') + ')'].join(' ')
    : t(`function.values.${userFunction}`);
  return (
    <Card className={`card-wrappers-company ${styleVariant}`}>
      <CardTitle className="card-headers">
        <div className="d-flex pt-3 align-items-center card-wrapper-users">
          <img className="rounded-circle avatar-user-image-company" src={pictureSrc} alt="user-avatar" />
          <p className="styled-text-label-company">
            {firstName} {lastName} <img src={clientIconUrl} title={clientIconName} alt="" />
          </p>
        </div>
        {children}
      </CardTitle>
      <CardBody className="styled-card-bodys">
        <ul className="styled-list-company">
          <li
            className="text-field-with-icon"
            style={{
              backgroundImage: `url(${isDarkMode ? mailIconWhite : mailIconDark})`,
            }}
          >
            {email}
          </li>
          {branchAddress === BRANCH_NOT_FOUND ? null : branchAddress ? (
            <li
              className="text-field-with-icon"
              style={{
                backgroundImage: `url(${isDarkMode ? BranchAddressIconWhite : BranchAddressIconDark})`,
              }}
            >
              {branchAddress}
            </li>
          ) : (
            <li
              className="text-field-with-icon"
              style={{
                backgroundImage: `url(${isDarkMode ? AddressCompanyIconWhite : AddressCompanyIconDark})`,
              }}
            >
              {address}
            </li>
          )}
          <li
            className="text-field-with-icon"
            style={{
              backgroundImage: `url(${isDarkMode ? userIconWhite : userIconDark})`,
            }}
          >
            {userFunctionLabel}
          </li>
        </ul>
      </CardBody>
    </Card>
  );
};

export default CardUserInfo;
